import { render, staticRenderFns } from "./OauthButton.vue?vue&type=template&id=05f5af48"
import script from "./OauthButton.vue?vue&type=script&lang=ts"
export * from "./OauthButton.vue?vue&type=script&lang=ts"
import style0 from "./OauthButton.vue?vue&type=style&index=0&id=05f5af48&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports